import { requestURLs } from "@/Environment";
import { useMutation } from "@tanstack/react-query";
import ApiRequest from "../ApiRequest";
import { TaskNote } from "./useAddTaskNotesMutation";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";

type UpdateNoteResponseType = ResponseType<TaskNote>;

export interface UpdateNotePayload {
  noteId?: string;
  note: string;
}

function useUpdateNoteMutation(defaultNoteId?: string) {
  const mutation = useMutation<
    AxiosResponseAndError<UpdateNoteResponseType>["response"],
    AxiosResponseAndError<UpdateNoteResponseType>["error"],
    UpdateNotePayload
  >({
    mutationFn: async (data) => {
      const targetNoteId = data.noteId || defaultNoteId;
      if (!targetNoteId) {
        throw new Error("noteId is required to update note");
      }
      return ApiRequest.put<UpdateNoteResponseType>(
        `${requestURLs.taskNote}${targetNoteId}`,
        { note: data.note }
      );
    },
  });

  return mutation;
}

export default useUpdateNoteMutation;